import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { Chat } from "../../../Shared/GeneratedTypes";
import { RECEIVE_CHAT, SEND_CHAT } from "../../../LiveSwitch/liveSwitchActionTypes";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";

// type actions = CurrentMentorsActions & LiveSwitchAction
export default function chatsReducer(
    state = initialState.chats,
    action: CurrentMentorsActions | LiveSwitchAction
): Chat[] {
    switch (action.type) {
        case types.LOAD_CURRENT_MENTORS_BY_ID_SUCCESS:
            return action.session.sessionInfo.chats;
        case SEND_CHAT: {
            return [...state, action.chat];
        }
        case RECEIVE_CHAT:
            return [...state, action.chat];
        default:
            return state;
    }
}
